import InputColourPicker from './InputColourPicker'
export default InputColourPicker
